<template>
	<div class="addr__item">
		<div class="addr__ico">
			<img :src="url + '/themes/polza/assets/img/ico-cart.svg'" alt="">
			<div class="addr__count">{{ count }}</div>
		</div>
		<div class="addr__podp">
			<span>В корзине:</span>
			<span>{{ total | cifer }} руб.</span>
			<a :href="url + '/cart'">В корзину</a>
		</div>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  export default {
    name: "top-cart",
    data() {
      return {
        cart: ''
      }
    },
    props: {
      items: '',
	    url: ''
    },
	  computed:{
      count(){
        if(!this.cart){
          return 0;
        } else {
          return Object.keys(this.cart).length;
        }
      },
      total(){
        let items = this.cart;
        let sum = 0;
        for (let key in items) {
          //console.log(key);
	        sum = sum + items[key]['total']*1;
        }
        return sum;
      },
	  },
	  methods: {
      reload(data){
        //console.log('Событие в корзине получил');
        //console.log(data);
        this.cart = data;
      }
	  },
	  mounted(){
      this.cart = this.items;
      bus.$on('cart-reload', this.reload)
	  }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/polza/src/js/components/commerce/top-cart.vue